import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import servicioService from '../../../service/administracion/servicioService';
import planCuentaService from '../../../service/administracion/planCuentaService';
import segmentoSunatService from '../../../service/administracion/segmentoSunatService';
import familiaSunatService from '../../../service/administracion/familiaSunatService';
import claseSunatService from '../../../service/administracion/claseSunatService';
import productoSunatService from '../../../service/administracion/productoSunatService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            planesCuenta: [],
            planesCuentaAutocomplete: [],
            segmentosSunat: [],
            clasesSunat: [],
            familiasSunat: [],
            productosSunat: [],
            estados: estadoMock.values,
            filter: {
                nombre: '',
                codigoRefencia: '',
                idPlanCuentaVenta: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    handleChangeForm = async (property, value, form) => {

        if (property === "idSegmentoSunat") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const familiasSunat = await familiaSunatService.listarPorIdSegmentoSunat(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    familiasSunat: familiasSunat ? familiasSunat : []
                }
            });
        }

        if (property === "idFamiliaSunat") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const clasesSunat = await claseSunatService.listarPorIdFamiliaSunat(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    clasesSunat: clasesSunat ? clasesSunat : []
                }
            });
        }

        if (property === "idClaseSunat") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const productosSunat = await productoSunatService.listarPorIdClaseSunat(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    productosSunat: productosSunat ? productosSunat : []
                }
            });
        }
    };

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            codigoReferencia: '',
            idImpuesto: 1,
            idPlanCuentaVenta: 0,
            flagIGVAfecto: true,
            flagISC: false,
            flagExonerado: false,
            planesCuenta: [],
            segmentosSunat: [],
            clasesSunat: [],
            familiasSunat: [],
            productosSunat: [],
            impuesto: [],
        }
    }

    handleClearFilters = async () => {
        var filter = {
            nombre: '',
            codigoRefencia: '',
            idPlanCuentaVenta: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };

        this.setState({ filter });
    };

    handleSearchAutocomplete = (value) => {
        const result = this.state.planesCuenta.filter(item => {
            return (item.cuentaContable + ' - ' + item.nombre).toUpperCase().match(value.toUpperCase());
        }).slice(0, 75);
        this.setState({ planesCuentaAutocomplete: result });
    };

    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                idPlanCuentaVenta: value.key
            }
        });
    };

    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idPlanCuentaVenta: 0
            }
        });
    }

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await servicioService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Servicios.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await servicioService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Proyecto.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await servicioService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await servicioService.eliminar(values);
            else
                response = await servicioService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.planesCuenta = this.state.planesCuenta;
        formValues.segmentosSunat = this.state.segmentosSunat;
        formValues.impuesto = this.state.impuesto;

        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        const response = await servicioService.obtenerPorId(values.id);
        if (response !== undefined) {
            const familiasSunat = await familiaSunatService.listarPorIdSegmentoSunat(response.idSegmentoSunat);
            const clasesSunat = await claseSunatService.listarPorIdFamiliaSunat(response.idFamiliaSunat);
            const productosSunat = await productoSunatService.listarPorIdClaseSunat(response.idClaseSunat);
            response.familiasSunat = familiasSunat;
            response.clasesSunat = clasesSunat;
            response.productosSunat = productosSunat;
            response.planesCuenta = this.state.planesCuenta;
            response.segmentosSunat = this.state.segmentosSunat;
            response.impuesto = this.state.impuesto;

            this.setState({ visible: true, formValues: response });
        }
    };

    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await servicioService.registrar(values);
            else
                response = await servicioService.modificar(values);

            if (response.status === 200) {
                this.setState({ visible: false });
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, servicioService.paginacion);
        const planesCuenta = await planCuentaService.listarPorMayorGrado();
        const segmentosSunat = await segmentoSunatService.listar();
        const impuesto = await servicioService.listarImpuesto();

        this.setState({
            loadingSource: false,
            planesCuenta: planesCuenta ? planesCuenta : [],
            segmentosSunat: segmentosSunat ? segmentosSunat : [],
            impuesto: impuesto ? impuesto : []

        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Servicio"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    planesCuenta={this.state.planesCuentaAutocomplete}
                    estados={this.state.estados}
                    onSearchAutocomplete={this.handleSearchAutocomplete}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    onChangeForm={this.handleChangeForm}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    }
}